/* tslint:disable */
/* eslint-disable */
export enum DigitalWalletCertificateStatusEnum {
  New = 'New',
  Registered = 'Registered',
  Expired = 'Expired',
  Revoked = 'Revoked'
}
